import React, { Component } from 'react'
import { FormControl, Select, MenuItem, TextField } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DefFieldAmountSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currency:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.currency
                    ? this.props.item.settings.currency
                    : null,
            decimals:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.decimals
                    ? this.props.item.settings.decimals
                    : null,
            valueType:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.valueType
                    ? this.props.item.settings.valueType
                    : 'number',
        }
        this.onChange = this.onChange.bind(this)
    }

    onChange(event) {
        if (event.target.getAttribute('type') === 'checkbox') {
            this.props.onChange(event.target.name, event.target.checked)
            this.setState({ [event.target.name]: event.target.checked })
            return
        }
        this.props.onChange(event.target.name, event.target.value)
        this.setState({ [event.target.name]: event.target.value })
    }

    render() {
        const { kedo } = this.props
        const { valueType, decimals, currency } = this.state
        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{this.props.kedo.t('Type')}</FormInputLabel>
                    <Select
                        value={valueType}
                        name="valueType"
                        onChange={this.onChange}
                        size="small"
                    >
                        <MenuItem value="currency">
                            {kedo.t('Currency')}
                        </MenuItem>
                        <MenuItem value="number">{kedo.t('Number')}</MenuItem>
                        <MenuItem value="percentage">
                            {kedo.t('Percentage')}
                        </MenuItem>
                    </Select>
                </FormControl>
                {this.state.valueType === 'currency' ||
                this.state.valueType === 'number' ? (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {this.props.kedo.t('Decimals')}
                        </FormInputLabel>
                        <TextField
                            type="number"
                            name="decimals"
                            value={decimals}
                            onChange={this.onChange}
                            fullWidth
                            size="small"
                        />
                    </FormControl>
                ) : null}
                {this.state.valueType === 'currency' ? (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {this.props.kedo.t('Currency')}
                        </FormInputLabel>
                        <Select
                            value={currency}
                            name="currency"
                            onChange={this.onChange}
                            size="small"
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="COP">
                                {kedo.t('COP')} Colombian Peso
                            </MenuItem>
                            <MenuItem value="CRC">
                                {kedo.t('CRC')} Costa Rican Colón
                            </MenuItem>
                            <MenuItem value="EUR">
                                {kedo.t('EUR')} Euro
                            </MenuItem>
                            <MenuItem value="GBP">
                                {kedo.t('GBP')} British Pound Sterling
                            </MenuItem>
                            <MenuItem value="ILS">
                                {kedo.t('ILS')} Israeli New Sheqel
                            </MenuItem>
                            <MenuItem value="INR">
                                {kedo.t('INR')} Indian Rupee
                            </MenuItem>
                            <MenuItem value="JPY">
                                {kedo.t('JPY')} Japanese Yen
                            </MenuItem>
                            <MenuItem value="KRW">
                                {kedo.t('KRW')} South Korean Won
                            </MenuItem>
                            <MenuItem value="MAD">
                                {kedo.t('MAD')} Moroccan Dirham
                            </MenuItem>
                            <MenuItem value="NGN">
                                {kedo.t('NGN')} Nigerian Naira
                            </MenuItem>
                            <MenuItem value="PYG">
                                {kedo.t('PYG')} Paraguayan Guarani
                            </MenuItem>
                            <MenuItem value="PLN">
                                {kedo.t('PLN')} Polish Zloty
                            </MenuItem>
                            <MenuItem value="THB">
                                {kedo.t('THB')} Thai Baht
                            </MenuItem>
                            <MenuItem value="USD">
                                {kedo.t('USD')} US Dollar
                            </MenuItem>
                            <MenuItem value="UAH">
                                {kedo.t('UAH')} Ukrainian Hryvnia
                            </MenuItem>
                            <MenuItem value="VND">
                                {kedo.t('VND')} Vietnamese Dong
                            </MenuItem>
                        </Select>
                    </FormControl>
                ) : null}
            </div>
        )
    }
}

export default DefFieldAmountSettings
